import React, { useState } from 'react';
import styled from 'astroturf/react';

import Star from './Star';
import _Container from "Rating-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/Rating.tsx?styleId=Container";
import _StarContainer from "Rating-StarContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/RatingCard/Rating.tsx?styleId=StarContainer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const StarContainer = /*#__PURE__*/styled(Star, null, {
  displayName: "StarContainer",
  styles: _StarContainer
});

export type StarValue = 1 | 2 | 3 | 4 | 5;

type Props = {
  className?: string;
  stars?: StarValue;
  onChange: (value: StarValue) => void;
};

const Rating: React.FC<Props> = ({ className, stars, onChange }) => {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);

  return (
    <Container className={className}>
      {new Array(5).fill(null).map((_, index) => (
        <div
          key={index}
          onMouseEnter={() => setHoveredStar(index + 1)}
          onMouseLeave={() => setHoveredStar(null)}
          onClick={(e) => {
            e.stopPropagation();
            onChange((index + 1) as StarValue);
          }}
        >
          <StarContainer
            selected={
              hoveredStar == null && stars != null && stars >= index + 1
            }
            hovered={hoveredStar != null && hoveredStar >= index + 1}
          />
        </div>
      ))}
    </Container>
  );
};

export default Rating;
